module.exports = require('./DepBankParityFilingView');
